module.exports = require('./DepBankParityFilingView');
